import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "ui/components/dropdown-menu";

import { Button } from "ui/components/button";
import Icon from "components/icon";
import { MENU } from "icons";
import classNames from "classnames";

export default function Menu({ children, showOnHover = false, ...props }) {
  return (
    <DropdownMenu className="relative">
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className={classNames({
            "hidden cursor-pointer group-hover:flex transition-opacity duration-200 flex-1 border-1":
              showOnHover,
          })}
        >
          <Icon icon={MENU} className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>{children}</DropdownMenuContent>
    </DropdownMenu>
  );
}
